export default {"src":"/_next/static/media/Group-25848.62141248.svg","height":104,"width":104};